import React from "react";
import Button from "react-bootstrap/Button";
import "bootstrap/dist/css/bootstrap.min.css";
import Form from "react-bootstrap/Form";
// import ReactDOM from "react-dom/client";
import { useState } from "react";
import { countriesList } from "./countriesList2";
import axios from "axios";

const Register = () => {
    const [states, setStates] = useState([]);
    const [cities, setCities] = useState([]);
    const [IdCountry, setIdCountry] = useState([0]);
    const [IdState, setIdState] = useState(0);
    const [IdCity, setIdCity] = useState(0);

    const handleCountrySelection = (e) => {
        const value = e.target.value;
        setIdCountry(e.target.value);
        axios
            .get("http://tagard.in:8005/get/states/" + value + "/")
            .then((response) => {
                setStates(response.data);
            })
            .catch((error) => {
                console.error(error);
            });
    };

    const handleStateSelection = (e) => {
        const valuec = e.target.value;
        setIdState(valuec);
        axios
            .get("http://tagard.in:8005/get/cities/" + valuec + "/")
            .then((response) => {
                setCities(response.data);
            })
            .catch((error) => {
                console.error(error);
            });
    };

    const makeRequest = () => {
        const user__ = document.getElementById("UserName").value;
        const email__ = document.getElementById("Email").value;
        const password__ = document.getElementById("Password1").value;
        // document.getElementById("Password2").value
        const mobile__ = document.getElementById("Mobile").value;
        // const country__ = document.getElementById("countryID2").value;
        // const state__ = document.getElementById("stateID2").value;
        // const city__ = document.getElementById("cityID2").value;
        axios
            .post(
                "http://tagard.in:8005/usr/register",

                {
                    userName: user__,
                    email: email__,
                    mob: mobile__,
                    password: password__,
                    country: IdCountry,
                    state: IdState,
                    city: IdCity,
                }
            )
            .then((response) => {
                console.log(response.data);
                const resID = response.data.id;
                axios
                    .post("http://tagard.in:8005/influx/newinf/", {
                        USERNAME: user__,
                        email: email__,
                        userNid: resID,
                    })
                    .then((response1) => {
                        console.log(response1.status);
                    })
                    .catch((error) => {
                        console.error(error);
                    });
            })
            .catch((error) => {
                console.error(error);
            });
    };

    return (
        <>
            <Form className="w-50 ms-4 mt-5">
                <Form.Group className="mb-3">
                    <Form.Label>User Name</Form.Label>
                    <Form.Control
                        type="user"
                        placeholder="Enter your Name"
                        className="mb-3"
                        id="UserName"
                    />
                </Form.Group>
                <Form.Group className="mb-3">
                    <Form.Label>Email address</Form.Label>
                    <Form.Control
                        type="email"
                        placeholder="Enter email"
                        className="mb-3"
                        id="Email"
                    />
                </Form.Group>

                <Form.Group className="mb-3">
                    <Form.Label>Password</Form.Label>
                    <Form.Control
                        type="password"
                        placeholder="Password1"
                        className="mb-3"
                        id="Password1"
                    />
                </Form.Group>
                <Form.Group className="mb-3">
                    <Form.Control
                        type="password"
                        placeholder="Password2"
                        id="Password2"
                    />
                </Form.Group>
                <Form.Group className="mb-3">
                    <Form.Label>Mobile</Form.Label>
                    <Form.Control
                        type="text"
                        placeholder="Mobile No."
                        className="mb-3"
                        id="Mobile"
                    />
                </Form.Group>
                <Form.Group className="mb-3">
                    <Form.Label>Country</Form.Label>
                    <div>
                        <select
                            className="mb-3"
                            onChange={(e) => handleCountrySelection(e)}
                            id="CountryId"
                        >
                            <option>Select Country</option>
                            {countriesList.map((country) => {
                                return (
                                    <CountryOptions
                                        {...country}
                                        key={country.id}
                                    />
                                );
                            })}
                        </select>
                    </div>
                </Form.Group>
                <Form.Group className="mb-3">
                    <Form.Label>State</Form.Label>
                    <div>
                        <select
                            onChange={(e) => handleStateSelection(e)}
                            id="StateId"
                        >
                            <option>Select State</option>
                            {states.map((state) => {
                                return (
                                    <StatesOptions {...state} key={state.id} />
                                );
                            })}
                        </select>
                    </div>
                </Form.Group>
                <Form.Group className="mb-3">
                    <Form.Label>City</Form.Label>
                    <div>
                        <select
                            id="CityId"
                            onChange={(e) => {
                                setIdCity(e.target.value);
                            }}
                        >
                            <option>Select City</option>
                            {cities.map((city) => {
                                return (
                                    <CitiesOptions {...city} key={city.id} />
                                );
                            })}
                        </select>
                    </div>
                </Form.Group>

                <Button
                    variant="primary"
                    type="button"
                    onClick={() => {
                        makeRequest();
                    }}
                >
                    Submit
                </Button>
            </Form>
            {/* <Button onClick={() => console.log(states)}></Button> */}
        </>
    );
};

const CountryOptions = ({ id, name }) => {
    return (
        <option value={id} id="countryID2">
            {name}
        </option>
    );
};

const StatesOptions = ({ id, state }) => {
    return (
        <option value={id} id="stateID2">
            {state}
        </option>
    );
};

const CitiesOptions = ({ id, city }) => {
    return (
        <option value={id} id="cityID2">
            {city}
        </option>
    );
};

// const root = ReactDOM.createRoot(document.getElementById("root"));

// root.render(<App />);
export default Register;
